import { GRAPH_TYPES } from 'constants/countryProfile';
import { getScoreData, getCountrySectorScores, removeServerScoreData, transformObjectScoresFormat } from 'utils/data';
import { isStringSame, hasNonNullFields, uniqueValuesFilter } from 'utils/general';
import { isArray } from 'lodash-es';
import { SECTOR_NAME_MAPPING } from 'constants/common';
function parseCompareSectorData(data, name) {
  if (Object.keys(data).length) {
    const scoreData = getScoreData(data);
    return {
      name,
      categories: (data['country-sector-categories'] || []).map(el => transformObjectScoresFormat({ ...el,
        'country-sector-subcategories': (el['country-sector-subcategories'] || [])
        .map(subCat => transformObjectScoresFormat(subCat)) })),
      score: data.score,
      ...scoreData
    };
  }
  return {};
}

function getGraphType(type) {
  switch (type) {
    case GRAPH_TYPES.arc: return 'arc';
    case GRAPH_TYPES.bubbles: return 'bubbles';
    case GRAPH_TYPES.table: return 'table';
    default: return null;
  }
}
function getLawPracticeNumber(num, defaultValue = 0) {
  if (!isNaN(num)) return parseFloat(num);
  return defaultValue;
}
function getLawPracticeGraphData(data, year) {
  if (!data) return data;
  const updatedArray = [];
  data.forEach(el => {
    updatedArray.push({ ...el, 'law-2017': el['law-2017'] || el.law, 'practice-2017': el['practice-2017'] || el.practice, 'gap-2017': el['gap-2107'] || el.gap });
  });
  const modifedArray = [];
  updatedArray.forEach(el => {
    modifedArray.push({ ...el, law: getLawPracticeNumber(el[`law-${year}`]), practice: getLawPracticeNumber(el[`practice-${year}`]), gap: getLawPracticeNumber(el[`gap-${year}`]) });
  });

  return modifedArray;
}
function updateCountryScores(dataParsed) {
  const updatedData = dataParsed.map(el => {
    const updatedCountrySectors = [];
    if (el['country-sectors'] && el['country-sectors'].length) {
      el['country-sectors'].forEach(sec => {
        const updateSectorEl = removeServerScoreData({ ...sec, ...getScoreData(getCountrySectorScores(sec)) });
        if (hasNonNullFields(updateSectorEl, 'score', ['score'])) { updatedCountrySectors.push(updateSectorEl); }
      });
    }
    return { ...el, 'country-sectors': updatedCountrySectors };
  });
  return updatedData.filter(el => el && el['country-sectors'] && el['country-sectors'].length);
}


function concatCountriesYearsData(
  stateData = [],
  action = { payload: { data: [] } }
) {
  if (!action.payload.year || !stateData.length) {
    return action.payload.data;
  }

  const isoIndexMapping = {};
  const updatedStateData = stateData.map((el) => ({ ...el }));
  updatedStateData.forEach((el, index) => {
    isoIndexMapping[el.iso] = index;
  });
  if (isArray(action.payload.data)) {
    action.payload.data.forEach((el) => {
      if (isoIndexMapping[el.iso] >= 0) {
        updatedStateData[isoIndexMapping[el.iso]] = {
          ...updatedStateData[isoIndexMapping[el.iso]],
          ...el
        };
      } else updatedStateData.push(el);
    });
  }
  return updatedStateData;
}
function addServerLink(documentUri) {
  return documentUri && typeof documentUri === 'string'
                ? config.apiHost + documentUri
                : null;
}


const getLatestYearForDual = (mining, oilGas) => {
  const oilGasKeys = Object.keys(oilGas);
  const keys = Object.keys(mining).filter(
    (el) => el.startsWith('score') && oilGasKeys.includes(el)
  );
  let years = keys
    .filter((el) => mining[el] && oilGas[el])
    .map((el) => el.replace('score', ''))
    .filter((year) => year.length && !isNaN(year))
    .filter((item, i, ar) => ar.indexOf(item) === i)
    .map((y) => parseFloat(y));
  years = years.sort((a, b) => b - a);
  const selectedYear = years.length ? years[0] : 2017;
  return { selectedYear, years };
};

const getLatestYearForSingle = (sector) => {
  const keys = Object.keys(sector).filter((el) => el.startsWith('score'));
  let years = keys
    .filter((el) => sector[el])
    .map((el) => el.replace('score', ''))
    .filter((year) => year.length && !isNaN(year))
    .filter((item, i, ar) => ar.indexOf(item) === i)
    .map((y) => parseFloat(y));
  years = years.sort((a, b) => b - a);
  const selectedYear = years.length ? years[0] : 2017;
  return { selectedYear, years };
};

const getLatestDualSector = (item) => {
  let mining = item['country-sectors'].find(
    (sec) => String(sec.sector.name).toLowerCase() === 'mining'
  );
  let oilGas = item['country-sectors'].find(
    (sec) => String(sec.sector.name).toLowerCase() === 'oil-gas'
  );
  if (!mining || !oilGas) return { mining, oilGas, selectedYear: null };
  const { selectedYear, years: allYears } = getLatestYearForDual(mining, oilGas);
  mining = { ...mining, score: mining[`score${selectedYear}`] };
  oilGas = { ...oilGas, score: oilGas[`score${selectedYear}`] };
  return { mining, oilGas, selectedYear, allYears };
};

const getLatestSingleSector = (item) => {
  const selectedSector = item['country-sectors'][0];
  const { selectedYear, years: allYears } = getLatestYearForSingle(selectedSector) || 2017;
  return { selectedSector, selectedYear, allYears };
};

function isSectorsSame(sec1 = '', sec2 = '') {
  return isStringSame(sec1, sec2)
  || isStringSame(sec1, SECTOR_NAME_MAPPING[String(sec2).toLowerCase()])
  || isStringSame(sec2, SECTOR_NAME_MAPPING[String(sec1).toLowerCase()]);
}

function getAvailableYears(sectorData) {
  const scoreData = { ...getScoreData(getCountrySectorScores(sectorData)) };
  const yearsArr = Object.keys(scoreData)
    .filter((el) => scoreData[el])
    .filter((el) => el.startsWith('score'))
    .map((el) => el.replace('score', ''))
    .filter((el) => el.length && !isNaN(el))
    .sort((a, b) => parseFloat(b) - parseFloat(a));
  return yearsArr;
}

function getTempCountrySectorData(mapCountries = [], iso = null) {
  let tempSector = null;
  let sectors = [];
  let sectorsInfo = [];
  let documentUri = null;
  let documents = [];
  const selectedCountry = mapCountries.find(el => el.iso === iso) || {};
  if (selectedCountry && selectedCountry['country-sectors'] && selectedCountry['country-sectors'].length) {
    tempSector = {
      ...selectedCountry['country-sectors'][0],
      'country-sector-categories': [],
      'country-sector-subcategories': []
    };
    sectors = selectedCountry['country-sectors'].map(
        (sec) => sec.sector.name
      );
    sectorsInfo = selectedCountry['country-sectors'].map((sec) =>
        Object.assign({}, sec, { name: sec.sector.name })
      );
  }


  documentUri = selectedCountry['document-url'];
  documents = (selectedCountry.documents || []).map(el => ({ ...el, document: addServerLink(el.document) }));
  return { country: selectedCountry, tempSector, sectors, sectorsInfo, documentUri, documents };
}
function getTempCountryInfo(mapCountries, iso) {
  const {
    country,
    sectorsInfo,
    documents,
    documentUri,
    sectors
  } = getTempCountrySectorData(mapCountries, iso);
  const info = {
    country: country.name,
    sectorsInfo,
    documents: documents || [],
    documentUri: addServerLink(documentUri)
  };
  return { info, sectors };
}
function getUniqueSectorsName(sectorsInfo) {
  return sectorsInfo.map(
    (sec) => (sec.sector || {}).name
  ).filter(el => !!el).filter(uniqueValuesFilter);
}
export {
   parseCompareSectorData,
   getGraphType,
   concatCountriesYearsData,
   updateCountryScores,
   getLawPracticeGraphData,
   addServerLink,
   getLatestDualSector,
   getLatestSingleSector,
   getLatestYearForDual,
   getLatestYearForSingle,
   isSectorsSame,
   getAvailableYears,
   getTempCountrySectorData,
   getTempCountryInfo,
   getUniqueSectorsName
   };



// WEBPACK FOOTER //
// ./app/utils/countryProfile.js